/**
 *	週次プロモーション商品計画表帳票出力用VO
 */
export class KYMW1100ProofOutputModel {
  /**
   * 出力パラメタ
   */
  public pcode: string = <string>'';
  public itemCode: string = <string>'';
}
